import { defineTool } from '@/shell/tool';

/** Courses (Flutter `/courses`). */
export default defineTool({
  id: 'courses',
  title: 'Courses',
  summary: 'The courses the curriculum offers, and what each of them holds.',
  section: 'learning-backend',
  order: 20,
  icon: 'school',
  owner: '@Drabu',
  permission: 'courses:use',
  routes: () => import('./CoursesPage'),
});
